/**
 * AndVLiquid - 水波图组件
 * 基于 Ant Design Charts Liquid
 */
import React from 'react';
import { Liquid } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVLiquidProps } from '../base/types';

// 使用 HOC 包装基础 Liquid 组件
const LiquidWithBase = withBaseChart<AndVLiquidProps>(Liquid, {
  chartType: 'AndVLiquid',
  defaultHeight: 300,
  defaultData: 0.25, // Liquid 默认 percent (注意：Liquid 数据直接作为 percent 传递)
});

/**
 * AndVLiquid 水波图组件
 * 用于展示单个百分比数据的完成度
 */
export const AndVLiquid: React.FC<AndVLiquidProps> = (props) => {
  const {
    percent,
    ...baseProps
  } = props;

  const chartProps: Record<string, any> = {
    ...baseProps,
  };

  // 如果传递了 percent 属性，优先使用它
  // G2 Liquid 支持通过 percent 属性直接设置，也支持通过 data (但通常 percent 更直接)
  if (percent !== undefined) {
    chartProps.percent = percent;
  }

  return <LiquidWithBase {...chartProps} />;
};

export type { AndVLiquidProps };
export default AndVLiquid;
